var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticStyle:{"font-size":"14px","pointer-events":"none"},attrs:{"small":"","color":_vm.statusColor}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }